import type { PropsWithChildren } from "react";

import { Tooltip, type ITooltipProps } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

const DELAY: ITooltipProps["delay"] = {
    open: 300,
};

type Props = PropsWithChildren<{
    isEnabled?: boolean;
}>;

export const FiltersChipRemovedTooltip = ({ isEnabled, children }: Props) => {
    return (
        <Tooltip
            content={translate("si.filters-panel.filter.tooltip.removed")}
            enabled={isEnabled}
            delay={DELAY}
        >
            <div>{children}</div>
        </Tooltip>
    );
};
